/**
 * Minimum properties associated with the `aria-keyshortcuts` property.
 *
 * The aria key shortcuts type is used to expose shortcut keys to assistive technology.
 */
export type StateWithAriaKeyShortcuts = {
  root: {
    "aria-keyshortcuts"?: string;
  };
};

/**
 * Process the `draftState` as a mutable draft state and set the `aria-keyshortcuts` property according
 * to `valueOrDefaultValue`.
 */
export function useAriaKeyShortcuts<T extends StateWithAriaKeyShortcuts>(
  state: T,
  value?: string
) {
  if (value !== undefined) {
    state.root["aria-keyshortcuts"] = value;
  }
}
